export default __webpack_public_path__ + "static/media/founder-m.3dcf97a8.png";